import React, { useState } from "react";
import {
  Badge,
  Col,
  Collapse,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { IoChevronDown, IoChevronForward, IoChevronUp } from "react-icons/io5";
import filter1 from "../Images/Filter/filter_10.png";
import filter2 from "../Images/Filter/filter_11.png";
import filter3 from "../Images/Filter/filter_12.png";
import filter4 from "../Images/Filter/filter_13.png";
import filter5 from "../Images/Filter/filter_14.png";
import filter6 from "../Images/Filter/filter_15.png";
import filter7 from "../Images/Filter/filter_16.png";
import filter8 from "../Images/Filter/filter_17.png";
import filter9 from "../Images/Filter/filter_18.png";
import filter10 from "../Images/Filter/filter_19.png";
import filter11 from "../Images/Filter/fiter_20.png";
import filter12 from "../Images/Filter/filter_21.png";
import filter13 from "../Images/Filter/filter_22.png";
import filter14 from "../Images/Filter/filter_23.png";
import filter15 from "../Images/Filter/filter_24.png";
import filter16 from "../Images/Filter/filter_25.png";
import filter17 from "../Images/Filter/filter_26.png";
import filter18 from "../Images/Filter/filter_28.png";
import filter19 from "../Images/Filter/filter_29.png";
import filter20 from "../Images/Filter/filter_30.png";
import filter21 from "../Images/Filter/filter_1.png";
import filter22 from "../Images/Filter/filter_2.png";
import filter23 from "../Images/Filter/filter_3.png";
import filter24 from "../Images/Filter/filter_4.png";
import filter25 from "../Images/Filter/filter_5.png";
import filter26 from "../Images/Filter/filter_6.png";
import filter27 from "../Images/Filter/filter_7.png";
import filter28 from "../Images/Filter/filter_8.png";
import filter29 from "../Images/Filter/filter_9.png";
import filter30 from "../Images/06.jpg";
import { RxCross2 } from "react-icons/rx";

const FilterPage = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showDate, setShowDate] = useState(false);

  const [selectedOthers, setSelectedOthers] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedActors, setSelectedActors] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);

  const handleshowLangg = () => {
    setShow(!show);
    if (visible) setVisible(false);
  };

  const handleShowActors = () => {
    setVisible(!visible);
    if (show) setShow(false);
    if (showDate) setShowDate(false);
  };

  const handleShowDate = () => {
    setShowDate(!showDate);
    if (visible) setVisible(false);
  };

  const handleSelect = (value, setter, selected) => {
    if (!selected.includes(value)) {
      setter([...selected, value]);
    }
  };

  const handleRemove = (value, setter, selected) => {
    setter(selected.filter((item) => item !== value));
  };

  const filter_image = [
    filter1,
    filter2,
    filter3,
    filter4,
    filter5,
    filter6,
    filter7,
    filter8,
    filter9,
    filter10,
    filter11,
    filter12,
    filter13,
    filter14,
    filter15,
    filter16,
    filter17,
    filter18,
    filter19,
    filter20,
    filter21,
    filter22,
    filter23,
    filter24,
    filter25,
    filter26,
    filter27,
    filter28,
    filter29,
    filter30,
  ];

  return (
    <Container fluid>
      <Row>
        <Form.Group as={Col} md={12} className="p-0">
          <div className="py-3 hstack justify-content-between px-4">
            <div className="hstack gap-2">
              <Badge bg="dark" className="px-3 py-2 fs-15 fw-bold rounded-5">
                Crime
              </Badge>
              <Badge bg="dark" className="px-3 py-2 fs-15 fw-bold rounded-5">
                Comedy
              </Badge>
              <Badge bg="dark" className="px-3 py-2 fs-15 fw-bold rounded-5">
                Romance
              </Badge>
              <Badge bg="dark" className="px-3 py-2 fs-15 fw-bold rounded-5">
                Action
              </Badge>
              <Badge bg="dark" className="px-3 py-2 fs-15 fw-bold rounded-5">
                Mystery
              </Badge>
              <div>
                <Badge
                  bg="dark"
                  className="px-3 py-2 fs-15 fw-bold rounded-5 d-flex align-items-center"
                  onClick={() => setOpen(!open)}
                  style={{ cursor: "pointer" }}
                >
                  Others
                  {open ? (
                    <IoChevronUp className="ms-1" />
                  ) : (
                    <IoChevronDown className="ms-1" />
                  )}
                </Badge>
                <Collapse in={open}>
                  <div
                    className="pt-2 position-absolute bg-dark border rounded z-1"
                    style={{ top: 108 }}
                  >
                    <div class="d-flex justify-content-between ps-2 py-2 shadow-sm">
                      <Form.Control
                        type="text"
                        className="me-2 py-1 px-2 w-75 search_input"
                        placeholder="Search"
                      />
                      <div href="#" className="clear-link px-2">
                        Clear
                      </div>
                    </div>
                    <div
                      class="ps-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {[
                        "Fantasy",
                        "Feature Film",
                        "History",
                        "Hollywood",
                        "Horror",
                        "Kids",
                        "Martial Arts",
                        "Musical",
                        "Adventure",
                        "Animation",
                        "Biopic",
                        "Bollywood",
                        "Dance",
                        "Document",
                        "Drama",
                        "Dubbed",
                        "Educational",
                        "Erotic",
                        "Family",
                      ].map((item) => (
                        <div className="form-check" key={item}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            onChange={() =>
                              handleSelect(
                                item,
                                setSelectedOthers,
                                selectedOthers
                              )
                            }
                            checked={selectedOthers.includes(item)}
                          />
                          <label className="form-check-label">{item}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
            <div className="hstack gap-2">
              <Badge
                bg="primary"
                className="px-3 py-2 fs-15 fw-bold rounded-5 cursor-pointer"
                onClick={handleshowLangg}
              >
                Language
                {show ? (
                  <IoChevronUp className="ms-1" />
                ) : (
                  <IoChevronDown className="ms-1" />
                )}
              </Badge>
              <Collapse in={show}>
                <div
                  className="pt-2 position-absolute  bg-dark border rounded z-1"
                  style={{ top: 104, right: 195 }}
                >
                  <div class="d-flex justify-content-between ps-2 py-2 shadow-sm">
                    <Form.Control
                      type="text"
                      className="me-2 py-1 px-2 w-75 search_input"
                      placeholder="Search"
                    />
                    <div href="#" className="clear-link px-2">
                      Clear
                    </div>
                  </div>
                  <div
                    class="ps-2"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    {[
                      "Bengali",
                      "Bhojpuri",
                      "English",
                      "Gujarati",
                      "Hindi",
                      "Kannada",
                      "Malayalam",
                      "Marathi",
                      "Nepali",
                      "Punjabi",
                      "Tamil",
                      "Telugu",
                      "Urdu",
                    ].map((lang) => (
                      <div className="form-check" key={lang}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          onChange={() =>
                            handleSelect(
                              lang,
                              setSelectedLanguages,
                              selectedLanguages
                            )
                          }
                          checked={selectedLanguages.includes(lang)}
                        />
                        <label className="form-check-label">{lang}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </Collapse>
              <Badge
                bg="dark"
                className="px-3 py-2 fs-15 fw-bold rounded-5"
                onClick={handleShowActors}
                style={{ cursor: "pointer" }}
              >
                Actor
                {visible ? (
                  <IoChevronUp className="ms-1" />
                ) : (
                  <IoChevronDown className="ms-1" />
                )}
              </Badge>
              <Collapse in={visible}>
                <div
                  className="pt-2 position-absolute bg-dark border rounded z-1"
                  style={{ top: 103, right: 67 }}
                >
                  <div class="d-flex justify-content-between ps-2 py-2 shadow-sm">
                    <Form.Control
                      type="text"
                      className="me-2 py-1 px-2 w-75 search_input"
                      placeholder="Search"
                    />
                    <div href="#" className="clear-link px-2">
                      Clear
                    </div>
                  </div>
                  <div
                    class="ps-2"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    {[
                      "Amir Khan",
                      "Abhishek Bacchan",
                      "Aishwarya Ray Bacchan",
                      "Ajay Devgan",
                      "Akshay Kumar",
                      "Alia Bhatt",
                      "Allu Arjun",
                      "Amitabh Bacchan",
                      "Amy jackson",
                      "Anupam Kher",
                      "Anupama",
                      "Bollywood",
                      "Anurag Kashyap",
                      "Anushka Sharma",
                      "Arjun Kapoor",
                      "Arya",
                      "Biju Menon",
                      "Bipasha Bashu",
                      "Chiranjeevi",
                      "Deepika Padukon",
                      "Danush",
                      "Dileep",
                      "Disha Patani",
                      "Hanshika Montana",
                      "Huma Qureci",
                      "Chiranjeevi",
                      "illeana D'cruxze",
                      "irrfan Khan",
                      "Jacqueline fardalize",
                      "JayaRam",
                      "John Abhram",
                      "Justin Bieber",
                      "Kajal",
                    ].map((actor) => (
                      <div className="form-check" key={actor}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          onChange={() =>
                            handleSelect(
                              actor,
                              setSelectedActors,
                              selectedActors
                            )
                          }
                          checked={selectedActors.includes(actor)}
                        />
                        <label className="form-check-label">{actor}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </Collapse>
              <Badge
                bg="dark"
                className="px-3 py-2 fs-15 fw-bold rounded-5"
                onClick={handleShowDate}
                style={{ cursor: "pointer" }}
              >
                Release Year
                {showDate ? (
                  <IoChevronUp className="ms-1" />
                ) : (
                  <IoChevronDown className="ms-1" />
                )}
              </Badge>
              <Collapse in={showDate}>
                <div
                  className="pt-2 position-absolute bg-dark border rounded z-1"
                  style={{ top: 104, right: 0 }}
                >
                  <div class="d-flex justify-content-between ps-2 py-2 shadow-sm">
                    <Form.Control
                      type="text"
                      className="me-2 py-1 px-2 w-75 search_input"
                      placeholder="Search"
                    />
                    <div href="#" className="clear-link px-2">
                      Clear
                    </div>
                  </div>
                  <div
                    class="ps-2"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    {[
                      "2014",
                      "2015",
                      "2016",
                      "2017",
                      "2018",
                      "2019",
                      "2020",
                      "2021",
                      "2022",
                      "2023",
                      "2024",
                      "2025",
                    ].map((year) => (
                      <div className="form-check" key={year}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          onChange={() =>
                            handleSelect(year, setSelectedYears, selectedYears)
                          }
                          checked={selectedYears.includes(year)}
                        />
                        <label className="form-check-label">{year}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} md={12} className="p-0">
          <div
            style={{ height: "calc(100vh - 120px" }}
            className="overflow-auto px-4"
          >
            <div className="mb-3">
              <Form.Label className="filter_dir">Home</Form.Label>
              <IoChevronForward className="text-white fs-10 me-2" />
              <Form.Label className="text-light">Browse All Movies</Form.Label>
            </div>
            <div>
              <p className="fw-bold text-light fs-18">Browse All Movies</p>
            </div>
            <div className="hstack justify-content-between">
              <div className="text-light fs-12 Browser_movieList mb-4">
                Watch the latest movies 2024 and Bollywood movies online. Get
                free streaming of English movies, Tamil movies
                <br />
                Telugu movies, other regional movies, new or old Hindi movies,
                Bollywood movies, HD movies of popular actors <br />
                like Akshay Kumar, Prabhas and others. Browse through the movies
                like Kanaka, Gujarati - Hellaro and others.
              </div>
              <div>
                {[
                  ...selectedOthers,
                  ...selectedLanguages,
                  ...selectedActors,
                  ...selectedYears,
                ].map((item) => (
                  <Form.Label key={item} className="text-light fs-12 me-2">
                    {item}{" "}
                    <RxCross2
                      className="text-primary cursor-pointer"
                      onClick={() => {
                        if (selectedOthers.includes(item))
                          handleRemove(item, setSelectedOthers, selectedOthers);
                        if (selectedLanguages.includes(item))
                          handleRemove(
                            item,
                            setSelectedLanguages,
                            selectedLanguages
                          );
                        if (selectedActors.includes(item))
                          handleRemove(item, setSelectedActors, selectedActors);
                        if (selectedYears.includes(item))
                          handleRemove(item, setSelectedYears, selectedYears);
                      }}
                    />
                  </Form.Label>
                ))}
              </div>
            </div>

            <div>
              <div className="hstack gap-4 flex-wrap">
                {filter_image?.map((image, index) => (
                  <Figure key={index}>
                    <Figure.Image
                      style={{ width: "100%", maxWidth: "185px" }}
                      height={180}
                      alt={`Image ${index + 1}`}
                      src={image}
                      className="zoom rounded"
                    />
                  </Figure>
                ))}
              </div>
            </div>
          </div>
        </Form.Group>
      </Row>
    </Container>
  );
};

export default FilterPage;
